import { useRecord, UseRecordOptions } from "./useRecord";

export function useDraftEdit(draftEditId?: string | null, options?: UseRecordOptions) {
  return useRecord("draft_edit", draftEditId, { name: "useDraftEdit", ...options });
}
